import PropTypes from 'prop-types';
// form
import { useFormContext, Controller } from 'react-hook-form';
// @mui
import { Radio, RadioGroup, FormHelperText, FormControlLabel } from '@mui/material';

// ----------------------------------------------------------------------

RHFRadioGroup.propTypes = {
  name: PropTypes.string,
  options: PropTypes.arrayOf(PropTypes.string),
  getOptionLabel: PropTypes.arrayOf(PropTypes.string),
  defaultValue:PropTypes.any,
   defaultChecked: PropTypes.any,
    onChange: PropTypes.any
};

export default function RHFRadioGroup({ name, options, getOptionLabel, defaultValue, defaultChecked, onChange, ...other }) {
  const { control } = useFormContext();

  return (
    <Controller
      name={name}
      control={control}
      render={({ field, fieldState: { error } }) => (
        <div style={{display: 'flex'}}>
          <RadioGroup {...field} row {...other}    
          defaultValue={defaultValue}
                defaultChecked={defaultChecked}
                style={{display: 'flex'}}
                >
            {options.map((option, index) => (
              <FormControlLabel
                key={option}
                value={option}
                defaultValue={defaultValue}
                defaultChecked={defaultChecked}
                onChange={onChange}
                control={<Radio style={{display: 'flex'}} />}
                label={getOptionLabel?.length ? getOptionLabel[index] : option}
                style={{display: 'flex'}}
              />
            ))}
          </RadioGroup>

          {!!error && (
            <FormHelperText error sx={{ px: 2 }}>
              {error.message}
            </FormHelperText>
          )}
        </div>
      )}
    />
  );
}
